import { List, Map } from 'immutable';

import { getSeletoresByConfig } from '../permissions/getSeletores.js';

export default function createMenu(config = {}) {
  const {
    integradoUnico = false,
    unicoUrl,
    unicoUrlParams,
    usaProcessoExterno,
    usaOuvidoria,
    isLogged,
    isCloud,
    cubejsIp,
    idEntidade
  } = config;

  const integradoUnicoFn = () => integradoUnico || isCloud;
  const isIntegradoUnicoAndNotCloudFn = () => integradoUnico && !isCloud;
  const notIntegradoUnicoFn = () => !integradoUnico && !isCloud;
  const getPathRoute = routePath => {
    return idEntidade ? `/${idEntidade}${routePath}` : routePath;
  };

  const permissions = getSeletoresByConfig(config);

  return List([
    Map({
      menu: 'Início',
      route: '/',
      caption: 'Início',
      image: 'fa fa-home',
      show: () => isLogged
    }),
    Map({
      menu: 'Abertura de Processo',
      route: () => getPathRoute('/aberturaProcessoExterno'),
      caption: 'Abertura de Processo',
      image: 'fa fa-file',
      show: () => !isLogged && usaProcessoExterno
    }),
    Map({
      menu: 'Consulta Autenticidade',
      route: () => getPathRoute('/consulta-autenticidade'),
      caption: 'Consulta Autenticidade',
      image: 'fa fa-download',
      show: () => !isLogged
    }),
    Map({
      menu: 'Consulta Processos',
      route: () => getPathRoute('/consultaProcesso'),
      caption: 'Consulta Processos',
      image: 'fa fa-search',
      show: () => !isLogged
    }),
    Map({
      menu: 'Ouvidoria',
      route: () => getPathRoute('/ouvidoria'),
      caption: 'Ouvidoria',
      image: 'fa fa-file',
      show: () => !isLogged && usaOuvidoria
    }),
    Map({
      menu: 'Cadastros',
      image: 'fa fa-edit',
      submenus: List([
        Map({
          route: '/assuntos',
          seletor: permissions.assunto,
          caption: 'Assuntos',
          image: 'fa fa-align-left fa-fw iconmoon'
        }),
        Map({
          route: '/atualizacao/pessoas',
          seletor: permissions.atualizacaoPessoa,
          caption: 'Atualização Pessoa',
          image: 'fa fa-users fa-fw iconmoon',
          show: notIntegradoUnicoFn
        }),
        Map({
          route: '/bairros',
          seletor: permissions.bairro,
          caption: 'Bairro',
          image: 'fa fa-map-signs fa-fw iconmoon',
          show: notIntegradoUnicoFn,
          isExternal: integradoUnico
        }),
        Map({
          route: '/caixas',
          seletor: permissions.caixa,
          caption: 'Caixa',
          image: 'fa fa-archive fa-fw iconmoon'
        }),
        Map({
          route: '/cidades',
          seletor: permissions.cidade,
          caption: 'Cidade',
          image: 'fa fa-archway fa-fw iconmoon',
          show: notIntegradoUnicoFn,
          isExternal: integradoUnico
        }),
        Map({
          route: '/coordenadorias',
          seletor: permissions.coordenadoria,
          caption: 'Coordenadoria',
          image: 'fa fa-address-card fa-fw iconmoon'
        }),
        Map({
          route: '/dashboards',
          seletor: permissions.cubeJs,
          caption: 'Dashboards',
          image: 'fa fa-cube',
          show: () => isLogged && integradoUnico && !!cubejsIp
        }),
        Map({
          route: '/diretorias',
          seletor: permissions.diretoria,
          caption: 'Diretoria',
          image: 'fa fa-building fa-fw iconmoon'
        }),
        Map({
          route: '/documentos',
          seletor: permissions.documentos,
          caption: 'Documentos',
          image: 'fa fa-folder-open fa-fw iconmoon'
        }),
        Map({
          route: '/gerencias',
          seletor: permissions.gerencia,
          caption: 'Gerência',
          image: 'fa fa-id-card fa-fw iconmoon'
        }),
        Map({
          route: '/grauSigilos',
          seletor: permissions.grauSigilo,
          caption: 'Grau Sigilo',
          image: 'fa fa-shield-alt iconmoon'
        }),
        Map({
          route: '/locais',
          seletor: permissions.local,
          caption: 'Local',
          image: 'fa fa-map-pin fa-fw iconmoon'
        }),
        Map({
          route: '/logradouros',
          seletor: permissions.logradouro,
          caption: 'Logradouro',
          image: 'fa fa-map-pin fa-fw iconmoon',
          show: notIntegradoUnicoFn,
          isExternal: integradoUnico
        }),
        Map({
          route: '/modelos-impressao',
          seletor: permissions.modeloImpressao,
          caption: 'Modelos de Impressão',
          image: 'fa fa-file iconmoon'
        }),
        Map({
          route: '/pessoas',
          seletor: permissions.pessoa,
          caption: 'Pessoa',
          image: 'fa fa-users fa-fw iconmoon',
          show: notIntegradoUnicoFn,
          isExternal: integradoUnico
        }),
        Map({
          route: '/roteiros',
          seletor: permissions.roteiro,
          caption: 'Roteiros',
          image: 'fa fa-directions iconmoon'
        }),
        Map({
          route: '/secretarias',
          seletor: permissions.secretaria,
          caption: 'Secretarias',
          image: 'fa fa-building fa-fw iconmoon'
        }),
        Map({
          route: '/situacoes',
          seletor: permissions.situacao,
          caption: 'Situação',
          image: 'fa fa-info fa-fw iconmoon'
        }),
        Map({
          route: '/tiposnotificacao',
          seletor: permissions.tipoNotificacao,
          caption: 'Tipos de Notificação',
          image: 'fa fa-comment fa-fw iconmoon'
        }),
        Map({
          route: '/tipos-participante',
          seletor: permissions.tipoParticipante,
          caption: 'Tipos de Participante',
          image: 'fa fa-user-edit fa-fw iconmoon'
        }),
        Map({
          route: '/tiposprocesso',
          seletor: permissions.tipo,
          caption: 'Tipos de Processo',
          image: 'fa fa-list-ul fa-fw iconmoon'
        }),
        Map({
          route: '/unidades',
          seletor: permissions.unidade,
          caption: 'Unidade',
          image: 'fa fa-building fa-fw iconmoon'
        }),
        Map({
          route: '/unidadesOrcamentaria',
          seletor: permissions.unidadeOrcamentaria,
          caption: 'Unidades Orçamentárias',
          image: 'fa fa-building fa-fw iconmoon'
        }),
        Map({
          route: '/usuarios',
          seletor: permissions.usuario,
          caption: 'Usuários',
          image: 'fa fa-user fa-fw iconmoon'
        })
      ])
    }),

    Map({
      menu: 'Cadastro Único',
      image: 'fa fa-file-export',
      show: integradoUnicoFn,
      submenus: List([
        Map({
          route: `${unicoUrl}/entidades${unicoUrlParams}`,
          seletor: permissions.entidade,
          caption: 'Entidade',
          image: 'fa fa-home iconmoon',
          show: isIntegradoUnicoAndNotCloudFn,
          isExternal: isIntegradoUnicoAndNotCloudFn()
        }),
        Map({
          route: `${unicoUrl}/pessoas${unicoUrlParams}`,
          seletor: permissions.pessoa,
          caption: 'Pessoa',
          image: 'fa fa-users fa-fw iconmoon',
          show: isIntegradoUnicoAndNotCloudFn,
          isExternal: isIntegradoUnicoAndNotCloudFn()
        }),
        Map({
          route: `${unicoUrl}/cidades${unicoUrlParams}`,
          seletor: permissions.cidade,
          caption: 'Cidade',
          image: 'fa fa-map fa-fw iconmoon',
          show: isIntegradoUnicoAndNotCloudFn,
          isExternal: isIntegradoUnicoAndNotCloudFn()
        }),
        Map({
          route: `${unicoUrl}/bairros${unicoUrlParams}`,
          seletor: permissions.bairro,
          caption: 'Bairro',
          image: 'fa fa-map-signs fa-fw iconmoon',
          show: isIntegradoUnicoAndNotCloudFn,
          isExternal: isIntegradoUnicoAndNotCloudFn()
        }),
        Map({
          route: `${unicoUrl}/logradouros${unicoUrlParams}`,
          seletor: permissions.logradouro,
          caption: 'Logradouro',
          image: 'fa fa-map-pin fa-fw iconmoon',
          show: isIntegradoUnicoAndNotCloudFn,
          isExternal: isIntegradoUnicoAndNotCloudFn()
        }),
        Map({
          route: '/unico-agencia',
          seletor: permissions.unicoCadastros,
          caption: 'Agência',
          image: 'fa fa-money-bill fa-fw iconmoon',
          show: () => isCloud
        }),
        Map({
          route: '/unico-bairro',
          seletor: permissions.unicoCadastros,
          caption: 'Bairro',
          image: 'fa fa-map-marker fa-fw iconmoon',
          show: () => isCloud
        }),
        Map({
          route: '/unico-cidade',
          seletor: permissions.unicoCadastros,
          caption: 'Cidade',
          image: 'fa fa-building fa-fw iconmoon',
          show: () => isCloud
        }),
        Map({
          route: '/unico-legislacao',
          seletor: permissions.unicoCadastros,
          caption: 'Legislação',
          image: 'fa fa-book-open fa-fw iconmoon',
          show: () => isCloud
        }),
        Map({
          route: '/unico-logradouro',
          seletor: permissions.unicoCadastros,
          caption: 'Logradouro',
          image: 'fa fa-map-signs fa-fw iconmoon',
          show: () => isCloud
        }),
        Map({
          route: '/unico-pessoa',
          seletor: permissions.unicoCadastros,
          caption: 'Pessoa',
          image: 'fa fa-users fa-fw iconmoon',
          show: () => isCloud
        })
      ])
    }),

    Map({
      route: '/arquivos-assinatura',
      seletor: permissions.assinatura,
      caption: 'Assinaturas',
      image: 'fa fa-file-signature'
    }),

    Map({
      menu: 'Processos',
      image: 'fa fa-list-ul',
      submenus: List([
        Map({
          route: `/processos-novo?filters==id.ano_Igual=${new Date().getFullYear()}`,
          seletor: permissions.processos,
          caption: 'Processos',
          image: 'fa fa-file iconmoon'
        }),
        Map({
          route: '/tramitacao-dinamica',
          seletor: permissions.processos,
          caption: 'Tramitação Dinâmica',
          image: 'fa fa-layer-group iconmoon'
        }),
        Map({
          route: '/comprovantes-entregas',
          seletor: permissions.comprovante,
          caption: 'Anexar comprovante de entrega',
          image: 'fa fa-clipboard-check iconmoon'
        }),
        Map({
          route: `/processos-avaliacao?filters==id.ano_Igual=${new Date().getFullYear()},externo_Igual=true,processoAvaliado_Igual=false`,
          seletor: permissions.aberturaCreate,
          caption: 'Avaliar Processos Externos',
          image: 'fa fa-check iconmoon'
        }),
        Map({
          route: '/correcaoFluxo',
          seletor: permissions.correcaoFluxo,
          caption: 'Correção de Fluxo',
          image: 'fa fa-undo fa-fw iconmoon'
        }),
        Map({
          route: '/vincular-processos',
          seletor: permissions.anexar,
          caption: 'Vincular Processos',
          image: 'fa fa-random iconmoon'
        })
      ])
    }),
    Map({
      menu: 'Indicadores',
      image: 'fa fa-sort-numeric-up',
      submenus: List([
        Map({
          route: '/indicador-processos-locais',
          seletor: permissions.indicadorProcessosLocais,
          caption: 'Processos x Locais',
          image: 'fa fa-file-upload fa-fw iconmoon'
        })
      ])
    }),
    Map({
      menu: 'Relatórios',
      image: 'fa fa-chart-pie',
      submenus: List([
        Map({
          route: '/processos/relatorios/comprovante-encaminhamento',
          seletor: isCloud
            ? permissions.relatorioComprovanteEncaminhamento
            : permissions.relatorios,

          caption: 'Comprovante de Encaminhamento',
          image: 'fa fa-receipt fa-fw iconmoon'
        }),
        Map({
          route: '/processos/relatorios/estatisticas-processos',
          seletor: isCloud
            ? permissions.relatorioEstatisticasProcessos
            : permissions.relatorios,

          caption: 'Estatísticas de Processos',
          image: 'fa fa-list-ul fa-fw iconmoon'
        }),
        Map({
          route: '/processos/relatorios/etiqueta',
          seletor: isCloud
            ? permissions.relatorioEtiqueta
            : permissions.relatorios,

          caption: 'Etiqueta',
          image: 'fa fa-tag fa-fw iconmoon'
        }),
        Map({
          route: '/processos/relatorios/geral',
          seletor: isCloud
            ? permissions.relatorioGeral
            : permissions.relatorios,
          caption: 'Processo',
          image: 'fa fa-copy fa-fw iconmoon'
        }),
        Map({
          route: '/unico-relatorios-dinamicos',
          seletor: permissions.unicoRelatorioDinamico,
          caption: 'Relatórios Dinâmicos',
          image: 'fa fa-file-alt iconmoon',
          show: integradoUnico && isCloud
        }),
        Map({
          route: '/processos/relatorios/tramite',
          seletor: isCloud
            ? permissions.relatorioTramite
            : permissions.relatorios,

          caption: 'Trâmite',
          image: 'fa fa-paper-plane fa-fw iconmoon'
        }),
        Map({
          route: '/processos/relatorios/tramite-por-local',
          seletor: isCloud
            ? permissions.relatorioTramite
            : permissions.relatorios,

          caption: 'Trâmites Por Local',
          image: 'fa fa-paper-plane fa-fw iconmoon'
        })
      ])
    }),

    Map({
      menu: 'Consultas',
      image: 'fa fa-search',
      show: integradoUnico && isCloud,
      submenus: List([
        Map({
          route: '/unico-consultas-dinamicas',
          seletor: permissions.unicoConsultaDinamica,
          caption: 'Consultas Dinâmicas',
          image: 'fa fa-magic iconmoon',
          show: integradoUnico && isCloud
        })
      ])
    }),

    Map({
      menu: 'Modelos de Documentos',
      image: 'fa fa-file-alt',
      submenus: List([
        Map({
          route: '/modelos-documentos',
          seletor: permissions.modelosDocumentos,
          caption: 'Modelos',
          image: 'fa fa-table fa-fw iconmoon'
        }),
        Map({
          route: '/variaveis',
          seletor: permissions.variaveis,
          caption: 'Variáveis/Sql',
          image: 'fa fa-list iconmoon'
        })
      ])
    }),

    Map({
      menu: 'Configurações',
      image: 'fa fa-cogs',
      submenus: List([
        Map({
          route: '/parametros',
          seletor: permissions.parametros,
          caption: 'Parâmetros',
          image: 'fa fa-tasks fa-fw iconmoon'
        }),
        Map({
          route: '/enviar-processos',
          seletor: permissions.integracaoTributos,
          caption: 'Integração Processos Tributos',
          image: 'fa fa-file iconmoon'
        }),
        Map({
          route: '/assinatura-configuracao',
          seletor: permissions.assinaturaConfig,
          caption: 'Configuração Assinatura',
          image: 'fa fa-file-signature iconmoon'
        })
      ])
    })
  ]);
}
